import React from 'react'
import cn from 'classnames'
import { isEnterpriseUser } from '@mc/user-info'
import { Icon } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'

import Link from './Link'
import classes from './Title.module.scss'
import enterpriseLogo from './mc-enterprise-logo-light-theme.svg'

const MasterClassLogo = ({ minimalLogo }: { minimalLogo?: boolean }) => (
  <>
    {minimalLogo ? (
      <Icon kind='logo' className='mc-icon--5' />
    ) : (
      <div className='d-flex align-items-center'>
        <Icon
          kind='logo'
          className='mc-icon--4 mc-mr-2 mc-text-color--primary'
        />
        <Icon
          className='d-none d-sm-block'
          kind='logo-wordmark'
          style={{ width: 100 }}
        />
      </div>
    )}
  </>
)

const MasterClassEnterpriseLogo = () => (
  <img
    className={classes.enterpriseLogo}
    src={enterpriseLogo}
    alt='MasterClass At Work Logo'
  />
)

const Title = ({
  minimalLogo,
  label,
  as,
  href = '/',
}: {
  minimalLogo?: boolean
  label?: string
  as?: 'a'
  href?: string
}) => {
  const { t } = useTranslation('@mc/monolith/entries/navigation')

  return (
    <div className='col-auto d-flex align-items-center'>
      <Link className={classes.noLineHeight} href={href} as={as}>
        <span className='mc-sr-only'>{t('logoSrText')}</span>
        {isEnterpriseUser() ? (
          <MasterClassEnterpriseLogo />
        ) : (
          <MasterClassLogo minimalLogo={minimalLogo} />
        )}
      </Link>
      {label && (
        <span
          className={cn(
            classes.noLineHeight,
            'mc-ml-2 mc-text-large mc-opacity--muted',
          )}
        >
          {label}
        </span>
      )}
    </div>
  )
}

export default Title
